// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq_faq__Mdpij","item":"faq_item__1d-48","class1":"faq_class1__2tIpf","class2":"faq_class2__1Hm79"};